





























































































































































































































































































import { View } from 'client-website-ts-library/plugins';
import { API, Config } from 'client-website-ts-library/services';
import { Component, Mixins, Vue } from 'vue-property-decorator';

@Component
export default class PrivacyPolicy extends Mixins(View) {
  private businessName: string | null = null;

  mounted() {
    API.Franchises.Get(Config.Website.Settings!.WebsiteId).then((franchise) => {
      this.businessName = franchise.Name;
    });
  }
}
